export const columnFields = ['name', 'countryCode'] as const;

export const adminColumnFields = ['name'] as const;

// oxlint-disable-next-line no-unused-vars
type _AdminColumnFieldsSafetyNet<
	T extends (typeof columnFields)[number] = (typeof adminColumnFields)[number],
> = T;
